import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { pharmacyState } from '@/recoil/pharmacy';
import CacheRoute, {
  CacheRouteProps,
  CacheSwitch
} from 'react-router-cache-route';

/** Page */
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import FindAccountPage from './pages/FindAccountPage';
import RequestedOrdersPage from './pages/RequestedOrdersPage';
import PreparingOrdersPage from './pages/PreparingOrdersPage';
import LoadingPage from './pages/LoadingPage';
import { useIsFetching, useIsMutating } from 'react-query';
import OrderDetailPage from './pages/OrderDetailPage';
import HistoryOrdersPage from './pages/HistoryOrdersPage';
import Mypage from './pages/Mypage';
import NoticePage from './pages/NoticePage';
import NoticeDetailPage from './pages/NoticeDetailPage';
import _ from 'lodash';
import { authState } from './recoil/auth';
import TermAgreePage from './pages/TermAgreePage';
import TermPage from './pages/TermPage';
import MedicinePage from './pages/MedicinePage';

const Router = () => {
  const pharmacy = useRecoilValue(pharmacyState);
  const auth = useRecoilValue(authState);

  const isFetching = !!useIsFetching();
  const isMutating = !!useIsMutating();
  const isLoggedIn = !_.isEmpty(pharmacy) && !!auth.token;

  return (
    <>
      <LoadingPage isVisible={isFetching || isMutating} />
      {!isLoggedIn ? (
        <Switch>
          <Route exact path="/" component={() => <Redirect to="/login" />} />
          <Route path="/login" component={LoginPage} />
          <Route path="/signup" component={SignupPage} />
          <Route path="/findAccount" component={FindAccountPage} />
          <Route path="*" component={() => <Redirect to="/login" />} />
        </Switch>
      ) : (
        <CacheSwitch>
          <Route
            exact
            path="/"
            component={() => <Redirect to="/requested" />}
          />
          <CacheRoute
            exact
            path="/requested"
            component={RequestedOrdersPage}
            when={(props: CacheRouteProps) =>
              /^\/requested\/\d+$/.test(props.location?.pathname!)
            }
          />
          <CacheRoute
            exact
            path="/preparing"
            component={PreparingOrdersPage}
            when={(props: CacheRouteProps) =>
              /^\/preparing\/\d+$/.test(props.location?.pathname!)
            }
          />
          <CacheRoute
            exact
            path="/history"
            component={HistoryOrdersPage}
            when={(props: CacheRouteProps) =>
              /^\/history\/\d+$/.test(props.location?.pathname!)
            }
          />
          <Route exact path="/history/:id" component={OrderDetailPage} />
          <Route exact path="/mypage" component={Mypage} />
          <Route exact path="/medicine" component={MedicinePage} />
          <Route exact path="/notice" component={NoticePage} />
          <Route path="/requested/:id" component={OrderDetailPage} />
          <Route path="/preparing/:id" component={OrderDetailPage} />
          <Route path="/notice/:id" component={NoticeDetailPage} />
          <Route path="/term" component={TermPage} />
          <Route path="/termAgree" component={TermAgreePage} />
          <Route path="*" component={() => <Redirect to="/requested" />} />
        </CacheSwitch>
      )}
    </>
  );
};

export default Router;
